import { useTheme } from "../contexts/ThemeContext";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      data-testid="theme-toggle"
      aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
      title={isDark ? "Switch to light" : "Switch to dark"}
      className={`relative inline-flex items-center w-[86px] h-[30px] border border-[var(--border-strong)] bg-[var(--surface)] hover:border-[var(--color-primary)] transition-colors group ${className}`}
    >
      <span
        className={`absolute top-1/2 -translate-y-1/2 w-[24px] h-[24px] flex items-center justify-center transition-all duration-300 ${
          isDark
            ? "left-[2px] bg-[#0a0a0a] text-[#fce74d]"
            : "left-[58px] bg-[#fce74d] text-black"
        }`}
      >
        {isDark ? <Moon size={13} strokeWidth={2} /> : <Sun size={13} strokeWidth={2} />}
      </span>
      <span
        className={`absolute font-mono text-[10px] font-medium tracking-[0.18em] uppercase pointer-events-none text-[var(--text-70)] ${
          isDark ? "left-[34px]" : "left-[10px]"
        }`}
      >
        {isDark ? "DARK" : "LIGHT"}
      </span>
    </button>
  );
}
